module.exports = __webpack_public_path__ + "media/images/badge/nostradamus-52f17399cf2eb8f1e2260d8b60e6c969.png";